module.exports = __webpack_public_path__ + "img/ba.71010df.svg";